import { render, staticRenderFns } from "./HeaderGlobalSearch.vue?vue&type=template&id=d48ae074&scoped=true"
import script from "./HeaderGlobalSearch.vue?vue&type=script&lang=js"
export * from "./HeaderGlobalSearch.vue?vue&type=script&lang=js"
import style0 from "./HeaderGlobalSearch.vue?vue&type=style&index=0&id=d48ae074&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48ae074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d48ae074')) {
      api.createRecord('d48ae074', component.options)
    } else {
      api.reload('d48ae074', component.options)
    }
    module.hot.accept("./HeaderGlobalSearch.vue?vue&type=template&id=d48ae074&scoped=true", function () {
      api.rerender('d48ae074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/HeaderGlobalSearch.vue"
export default component.exports